// must import   <script src="https://cdn.paddle.com/paddle/v2/paddle.js"></script> in html
function setup() {
  const isTesting = !window.location.hostname.startsWith('www');

  console.log('Initializing Paddle ', isTesting);
  let token = 'live_7065d3abffa3906834d39f7e8fd';
  let paddleEnv = 'production';
  if (isTesting) {
    token = 'test_233ce5f6334d8e4b9a658161096';
    paddleEnv = 'sandbox';
  }

  Paddle.Initialize({
    token,
  });
  Paddle.Environment.set(paddleEnv);
  console.log('Finished Initializing Paddle');

  function subscriptionPay(teamType) {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');
    const userID = urlParams.get('userID');
    const seats = Number(urlParams.get('seats'));
    let priceId = '';

    if (teamType === 'TEAMS_PRO') {
      priceId = 'pri_01j29wep1gn000gxaa99emx8zh';
      if (isTesting) {
        // sandbox price ids
        priceId = 'pri_01j2c88f76zcb06ssxksfvbsp0';
      }
    }
    if (teamType === 'TEAM_BASIC') {
      priceId = 'pri_01j1dg6v56b7f2nt9wbzpemtc2';

      if (isTesting) {
        // sandbox price ids
        priceId = 'pri_01j2c897nbbnfd3xj6ans7503t';
      }
    }

    console.log('Opening Paddle Checkout');

    Paddle.Checkout.open({
      settings: {
        allowLogout: false,
        successUrl: `${window.location.origin}/upgrade-for-business-success.html`,
      },
      items: [{ quantity: seats, priceId }],
      customer: {
        email,
      },
      customData: {
        userID,
      },
    });
  }

  document
    .getElementById('payTeamBasic')
    .addEventListener('click', () => subscriptionPay('TEAM_BASIC'));

  document
    .getElementById('payTeamPro')
    .addEventListener('click', () => subscriptionPay('TEAMS_PRO'));
}

window.onload = setup;
